var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAva(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00B8E9;}\r\n\t.st1{fill:#DCC5A1;}\r\n\t.st2{fill:#EDD9B4;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#BC9F82;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#E5917A;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#422F18;}\r\n\t.st7{fill:#342214;}\r\n\t.st8{fill:#3E7EBC;}\r\n\t.st9{fill:#89BCE5;}\r\n\t.st10{fill:#BE1E2D;}\r\n\t.st11{fill:#E6E6E5;}\r\n\t.st12{fill:#1B75BC;}\r\n\t.st13{fill:#314E67;}\r\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.2,374.5c10-8.9,34.1-27.7,108.8-61.8c0.5-0.2,1-0.5,1.5-0.7l16.7-7.5c0.3-0.1,0.6-0.3,0.9-0.4v20.3   l3.8,32.9c18.1-5.2,41.2-10.7,41.2-10.7l40.4,13.9l4.2-36.2l0-20.2c0.5,0.2,0.9,0.4,1.4,0.6l7.8,3.5c5,2.2,9.7,4.4,14.3,6.5   c9.6,4.4,18.3,8.5,26.2,12.4c51.6,25.3,69.7,39.8,78.3,47.4c3.4,3,6.6,7.8,9.4,13.8c21.2-33.4,33.5-73,33.5-115.5   C471.7,153.6,375.1,57,256,57S40.3,153.6,40.3,272.8c0,42.5,12.3,82.1,33.5,115.5C76.7,382.3,79.8,377.6,83.2,374.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.2,222.1v102.4c12.3,14.6,28.6,22.1,44.8,22.3V180.6C233.6,180.6,211.2,194.4,211.2,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,180.6v166.1c16.3,0.1,32.5-7.2,44.8-22.3V222.1C300.8,194.4,278.4,180.6,256,180.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300.8,220.2v65.5c-17,11.8-33.3,18.4-44.8,18.4c-11.5,0-27.9-6.6-44.8-18.4v-65.5   C211.2,167.4,300.8,167.4,300.8,220.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M204.4,219.2c0,0,43.6,14.7,98.4,0C302.8,219.2,262,268.6,204.4,219.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.4,219.2c0,0,45.5,15.8,98.4,0C271.2,217.6,277.8,216,204.4,219.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.4,219.2c0,0,48.6,47.1,98.4,0c0,0-10.7,34.1-46.7,34.2C220.1,253.6,204.4,219.2,204.4,219.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,38.3c-91.4,0-107.3,67.1-103.5,123c-4-3.4-8.3-4.9-12.1-3.6c-7.9,2.6-10.7,15.8-6.2,29.4    c4.5,13.7,14.5,22.6,22.4,20c1-0.3,2-0.9,2.8-1.6c3.7,15.1,7.9,25.9,10,29c10.8,16,62.2,58.3,86.5,58.3h0L256,38.3L256,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M371.3,157.7c-3.7-1.2-7.9,0.1-11.7,3.3c3.7-55.9-12.3-122.7-103.6-122.7v254.6c24.3,0,75.7-42.3,86.5-58.3    c2.1-3.1,6.2-13.8,9.9-28.7c0.8,0.6,1.6,1,2.5,1.3c7.9,2.6,18-6.4,22.4-20C381.9,173.5,379.2,160.3,371.3,157.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M187.2,99.1c-8.7,47.7-30.6,43.2-28.9,99.2c-7-43.6-17.5-101.7,12.1-139.9c23.7-30.6,102.2-52.4,153-15.8   c56.1,12,38.6,126.3,31.1,147.9c-5.3-35-17-49.6-31.9-90.7C302.5,114.3,213.1,117.5,187.2,99.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M212.9,158.6c5.8,0,10.6,5.4,10.6,12c0,6.6-4.7,12-10.6,12c-5.8,0-10.6-5.4-10.6-12    C202.3,163.9,207,158.6,212.9,158.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M298.7,158.6c5.8,0,10.6,5.4,10.6,12c0,6.6-4.7,12-10.6,12c-5.8,0-10.6-5.4-10.6-12    C288.2,163.9,292.9,158.6,298.7,158.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M234,234.5c3.8,8.3,12.1,14.1,21.8,14.1c9.7,0,18.1-5.8,21.8-14.1H234z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M193.5,312l16.7-7.5C204.5,307.1,198.9,309.6,193.5,312z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M302.2,304.8l7.8,3.5C307.5,307.1,304.9,306,302.2,304.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M192,312.7L192,312.7c0.5-0.2,1-0.5,1.5-0.7L192,312.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M211.2,304.1l-0.9,0.4C210.6,304.4,210.9,304.2,211.2,304.1L211.2,304.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M324.2,314.6l-14.2-6.3c5,2.2,9.7,4.4,14.3,6.5L324.2,314.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M300.8,304.2L300.8,304.2c0.5,0.2,0.9,0.4,1.4,0.6L300.8,304.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "256,488.5 256,488.5 256,488.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M137.1,452.8c1.2-9.4,2-15.2,2-15.2s0,6.2,0,16.5c15.7,10.2,32.9,18.3,51.1,24.2l-29.9-60.7l35.2-23.5   l-43-20.1l39.5-61.3c-74.7,34.1-98.8,52.9-108.8,61.8c-3.4,3-6.6,7.8-9.4,13.8C90.1,414,111.7,436,137.1,452.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M428.8,374.5c-8.5-7.6-26.7-22.1-78.3-47.4c-7.9-3.9-16.6-8-26.2-12.4l35,59.3l-43,20.1l35.2,23.5l-29.9,60.8   c18.3-5.8,35.5-14,51.3-24.2c0-10.3,0-16.5,0-16.5s0.8,5.7,2,15.2c25.4-16.8,47-38.8,63.3-64.5   C435.3,382.3,432.2,377.6,428.8,374.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M230,486.9l0.1,1.1c0.9,0,1.7,0.1,2.6,0.1l0.1-0.8C231.9,487.2,231,487.1,230,486.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M230,486.9c0.9,0.1,1.9,0.2,2.8,0.3l14.7-103l-12-16.6l20.6-21c0,0-23.1,5.5-41.2,10.7L230,486.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M279.2,487.3l0.1,0.8c0.8,0,1.6-0.1,2.4-0.1l0.1-1C280.9,487.1,280,487.2,279.2,487.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M256.2,346.7l19.9,21l-11.8,16.6h0l14.7,103c0.9-0.1,1.8-0.2,2.7-0.3l14.8-126.4L256.2,346.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M215,357.4l-3.8-32.9v-20.3c-0.3,0.1-0.6,0.3-0.9,0.4l-16.7,7.5c-0.5,0.2-1,0.5-1.5,0.7L152.5,374l43,20.1   l-35.2,23.5l29.9,60.7c8.4,2.7,17,4.9,25.8,6.5c4.6,0.9,9.3,1.6,14,2.2L215,357.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M359.3,374l-35-59.3c-4.6-2.1-9.3-4.3-14.3-6.5l-7.8-3.5c-0.5-0.2-0.9-0.4-1.4-0.6l0,20.2l-4.2,36.2L281.8,487   c7.2-0.9,14.3-2.1,21.3-3.6c6.3-1.4,12.4-3.1,18.5-5l29.9-60.8l-35.2-23.5L359.3,374z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M264.4,384.3L264.4,384.3l11.8-16.6l-19.9-21l-20.6,21l12,16.6l-14.7,103c7.6,0.8,15.3,1.2,23.1,1.2   c0,0,0,0,0,0c7.8,0,15.5-0.4,23.1-1.2L264.4,384.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M137.1,452.8c0.7,0.4,1.3,0.9,2,1.3c0-10.3,0-16.5,0-16.5S138.3,443.3,137.1,452.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M372.9,454.1c0.7-0.4,1.3-0.9,2-1.3c-1.2-9.4-2-15.2-2-15.2S373,443.8,372.9,454.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "211.2,290.6 207.2,305.8 218.2,385.2 256.2,346.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "300.8,290.6 303.9,305.6 293.6,386 256.2,346.7  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAva);
export default __webpack_public_path__ + "static/media/ava.b07b70c1f18e633d4b2d602d712b606e.svg";
export { ForwardRef as ReactComponent };